export default {
    manage_createEditTemperature_EditTitle: "Edit Temperature Alert for",
    manage_createEditTemperature_CreateTitle: "Add new Temperature Alert",
    manage_createEditTemperature_success: "Temperature Alert was created successfully",
    manage_createEditTemperature_success_edit: "Temperature Alert was updated successfully",
    manage_createEditTemperature_inmediate: "Inmediate",
    manage_createEditTemperature_hour: "Hour",
    manage_createEditTemperature_UnitInputLabel: "Vehicle",
    manage_createEditTemperature_Enable: "Enable",
    manage_createEditTemperature_Disable: "Disable",
    manage_createEditTemperature_NameInputLabel: "Name",
    manage_createEditTemperature_minLengthMessage: "This field must contain minimum chars:",
    manage_createEditTemperature_maxLengthMessage: "This field must contain maximum chars:",
    manage_createEditTemperature_minTempMessage: "This temperature must be lower or equal to",
    manage_createEditTemperature_maxTempMessage: "This temperature must be higher or equal to",
    manage_createEditTemperature_HighInputLabel: "High (°F)",
    manage_createEditTemperature_LowInputLabel: "Low (°F)",
    manage_createEditTemperature_TriggerInputLabel: "Trigger",
    manage_createEditTemperature_AlertInputLabel: "Alert",
    manage_createEditTemperature_ContactsInputLabel: "Contacts",
    manage_createEditTemperature_once: "Once",
    manage_createEditTemperature_recurring: "Recurring",
    manage_createEditTemperature_error_fillAllEnabledZones: "Please fill all the required fields of the Enabled Zones"
}